import React from 'react'
import { withTranslation } from 'react-i18next'

const MultiSelectInstructions = ({ t }) => {
  return (
    <div className='ms-instructions'>
      <p className='ms-instructions__text'>{t('MULTI_SELECT_INSTRUCTIONS')}</p>
    </div>
  )
}

export default withTranslation()(MultiSelectInstructions)
